<template>
    <div>

        <!-- Top box -->

        <trax-ui-top-box :id="id" :endpoint="endpoint+'/'+programId" :props="props" :map="map" :bus="bus"
            edit-button="1"
            button-icon="edit" :button-name="lang.polaris.form.edit" :button-handler="edit">
        </trax-ui-top-box>

        <!-- Editing modal -->

        <trax-ui-modal-default :id="id" :bus="bus">
            <trax-training-program-crud-form :bus="bus" :id="id" :toastr-id="id+'-toastr'" :endpoint="endpoint">
            </trax-training-program-crud-form>
        </trax-ui-modal-default>

        <!-- Toastr -->

        <trax-ui-toastr :id="id+'-toastr'" :bus="bus" passed-label="1" no-progress="1">
        </trax-ui-toastr>

    </div>
</template>

<script>
    export default {

        props: {
            id: {default: 'trax-training-program-edit-top-box'},
            programId: null
        },

        data: function() {
            return {
                lang: lang,
                endpoint: app_url+'polaris/api/front/programs',
                props: {
                    name: { source:'name' },
                    description: {source: 'description'},
                    status: {source: 'status'},
                    background: {source: 'meta.background'}
                },
                map: {
                    title1: 'name',
                    description: 'description',
                    status: 'status',
                    backgroundImage: 'background'
                },
                bus: new Vue()
            }
        },

        methods: {

            edit: function(data) {
                this.bus.$emit(this.id+'-update', data);
            },

            statusName(data, type, row, meta) {
                var label = this.status_select.find(status => status.value == row.status).name
                var color = 'info';
                if (row.status == 'active') color = 'success';
                else if (row.status == 'maintenance') color = 'warning';
                else if (row.status == 'archived') color = 'default';
                return '<span class="badge badge-'+color+'">'+label+'</span>';
            }
        }
    }
</script>
